import React from "react"
import styled from "@emotion/styled"
import { formatText } from "../helper"

const Container = styled.div`
    padding: 1rem;
    text-align: center;
    background-color: #ffbfb0;
    color: black;
    border-radius: 0.25rem;
    margin-top: 1rem;
    font-size: inherit;
    font-family: 'Quicksand', sans-serif;
`

const Resumen = ({ data }) => {

    const { marca, year, plan } = data

    if (marca === "" || year === "" || plan === "") return null

    return (
        <Container>
           <h2>Resumen de cotización</h2>
           <ul>
               <li>Marca: {formatText(marca)} </li>
               <li>Plan: {formatText(plan)} </li>
               <li>Año: {year} </li>
           </ul>
        </Container>
    )
}

export default Resumen